module.exports = __webpack_public_path__ + "58d98865fca621bbbdd76de5f72b2eff.png";